<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
</div>
<div class="w-full min-h-screen p-6 bg-slate-50 full-page-container">
  <div class=" mx-auto flex flex-col gap-6">
    <div class="card">
      <div class="page-title-area p-3">
        <div>
          <h1 class="page-title text-4xl font-semibold">Liste des candidats au mentorat</h1>
          <p class="page-subtitle">Gérez et évaluez les candidatures au programme de mentorat</p>
        </div>
        <div class="stat-chip">
          <span class="stat-chip__value" *ngIf="dataSource?.data">
            {{ dataSource.data.length || 0 }}
          </span>
          <span class="stat-chip__label">candidats</span>
        </div>
      </div>
      <div class="filters-bar">
        <div class="tab-group" role="group" aria-label="Filtrer par statut">
          <button class="tab-btn" [class.tab-btn--active]="activeAll" (click)="applyFilterAll()">
            Tous les candidats
          </button>
          <button class="tab-btn" [class.tab-btn--active]="activeEnCours" (click)="applyFilterEnCours()">
            En cours
          </button>
          <button class="tab-btn" [class.tab-btn--active]="activeRetenus" (click)="applyFilterRetenus()">
            Retenus
          </button>
          <button class="tab-btn" [class.tab-btn--active]="activeRejetes" (click)="applyFilterRejetes()">
            Rejetés
          </button>
        </div>

        <div class="filters-right">
          <div class="search-field">
            <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" aria-hidden="true">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input type="text" class="input" placeholder="Rechercher un candidat…"
              (input)="applyFilterSearch($event)" />
          </div>

          <div class="select-field">
            <select class="input" [(ngModel)]="selectedCertificateId" (ngModelChange)="onCertificateSelectionChange()">
              <option [value]="-1" disabled>Choisir un certificat</option>
              <option [value]="0">Tous les certificats</option>
              <option *ngFor="let certificate of certificateOption" [ngValue]="certificate.id">
                {{ certificate.name }}
              </option>
            </select>
            <svg class="select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" aria-hidden="true">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>
        </div>
      </div>
      <div class="table-wrapper">
        <table id="listeCandidatsMentors" mat-table [dataSource]="dataSource" class="candidates-table"
          aria-label="Liste des candidats au mentorat">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Prénom Nom</th>
            <td mat-cell *matCellDef="let row">
              <div class="candidate-name">
                <div class="avatar" aria-hidden="true">
                  {{ row.firstname?.[0] }}{{ row.lastname?.[0] }}
                </div>
                <span class="candidate-name__full">{{ row.firstname }} {{ row.lastname }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef>Genre</th>
            <td mat-cell *matCellDef="let row">
              <span class="gender-badge gender-badge--{{ row.gender?.toLowerCase() }}">
                {{ row.gender || 'N/A' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Adresse e-mail</th>
            <td mat-cell *matCellDef="let row" class="text-slate-600 font-medium">
              {{ row.email }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombrecertificats">
            <th mat-header-cell *matHeaderCellDef>N.postulés</th>
            <td mat-cell *matCellDef="let row">
              <span class="cert-count">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.12M15 7a3 3 0 1 0-6 0v0a3 3 0 0 0 6 0v0z" />
                </svg>
                {{ row.certificats?.length || 0 }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="certificatsRetenus">
            <th mat-header-cell *matHeaderCellDef>{{ getColumnLabel() }}</th>
            <td mat-cell *matCellDef="let row">
              <span class="cert-filtered-count">{{ getNombreCertificatsFiltre(row) }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="deliberatedBy">
            <th mat-header-cell *matHeaderCellDef>Délibérer par</th>
            <td mat-cell *matCellDef="let row" class="text-slate-600 font-medium">
              {{ row.deliberatedBy ? row.deliberatedBy : '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button class="action-btn" (click)="togglePopup(row)" matTooltip="Voir les détails">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsFiltered"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsFiltered" class="table-row"></tr>
        </table>
      </div>

      <div class="empty-state-card"
        *ngIf="(spinnerService.spinner$ | async) === false && (!dataSource || dataSource.filteredData?.length === 0)">
        <div class="empty-state__icon-wrapper">
          <svg class="empty-state__icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" aria-hidden="true">
            <circle cx="11" cy="11" r="8" stroke-dasharray="3 3" />
            <path d="m21 21-4.35-4.35" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="11" cy="11" r="3" stroke-linecap="round" />
          </svg>
        </div>

        <h3 class="empty-state__title">Aucun candidat ne correspond</h3>
        <p class="empty-state__sub">Nous n'avons trouvé aucun résultat avec les filtres ou la recherche actuellement
          appliqués.</p>
      </div>

      <div class="paginator-wrapper">
        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </div>
  </div>
</div>


<!-- Modal de détails du candidat -->
<div *ngIf="popupVisible" tabindex="-1" aria-hidden="true" style="z-index: 99999"
  class="h-full bg-opacity-70 bg-gray-100 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 outline-none focus:outline-none justify-center items-start flex max-h-full">

  <div class="relative w-full my-10 mx-auto max-w-6xl px-4 animate-fade-in py-10">
    <div
      class="relative bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] dark:bg-gray-800 border border-gray-100 dark:border-gray-700 overflow-hidden">

      <div
        class="flex flex-col lg:flex-row lg:items-center justify-between p-8 border-b border-gray-50 dark:border-gray-700 bg-gradient-to-r from-gray-50 to-white dark:from-gray-800 dark:to-gray-800 gap-6">
        <div class="flex items-center gap-6 flex-grow">
          <button type="button" (click)="closeModalDetails()"
            class="group transition-all w-14 h-14 flex items-center justify-center bg-red-500 hover:bg-red-600 text-white rounded-2xl shadow-lg shadow-red-200 dark:shadow-none border border-transparent shrink-0">
            <svg class="w-7 h-7 transition-transform group-hover:rotate-90" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div class="min-w-0">
            <h2
              class="text-3xl md:text-5xl font-black text-gray-900 dark:text-white tracking-tighter uppercase leading-none">
              Détails du candidat
            </h2>
            <p class="text-blue-600 dark:text-blue-400 font-bold text-xl mt-2 flex items-center gap-2">
              <span class="h-1 w-4 bg-blue-600 rounded-full"></span>
              {{ ligneDetails?.firstname + " " + ligneDetails?.lastname }}
            </p>
          </div>
        </div>
      </div>

      <div class="p-6 md:p-10">
        <div class="grid gap-6 p-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <div class="p-5 rounded-2xl bg-blue-50/50 dark:bg-gray-700/30 border border-blue-100 dark:border-gray-600">
            <h3 class="text-[10px] font-bold uppercase tracking-widest text-blue-500 mb-2">Email</h3>
            <p class="text-gray-900 dark:text-white font-bold truncate">{{ ligneDetails?.email }}</p>
          </div>
          <div
            class="p-5 rounded-2xl bg-emerald-50/50 dark:bg-gray-700/30 border border-emerald-100 dark:border-gray-600">
            <h3 class="text-[10px] font-bold uppercase tracking-widest text-emerald-500 mb-2">Genre</h3>
            <p class="text-gray-900 dark:text-white font-bold">{{ ligneDetails?.gender }}</p>
          </div>
          <div class="p-5 rounded-2xl bg-amber-50/50 dark:bg-gray-700/30 border border-amber-100 dark:border-gray-600">
            <h3 class="text-[10px] font-bold uppercase tracking-widest text-amber-500 mb-2">Résidence</h3>
            <p class="text-gray-900 dark:text-white font-bold">{{ ligneDetails?.city }}</p>
          </div>
        </div>

        <div
          class="overflow-hidden bg-white dark:bg-gray-800 rounded-3xl border border-gray-100 dark:border-gray-700 shadow-sm">
          <table class="w-full text-left">
            <thead>
              <tr class="bg-gray-900 dark:bg-gray-700 text-white text-[11px] font-bold uppercase tracking-widest">
                <th class="px-6 py-4">Nom du Certificat</th>
                <th class="px-6 py-4 text-center">Cohorte</th>
                <th class="px-6 py-4 text-center">Statut</th>
                <th class="px-6 py-4 text-right">Évaluation</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-50 dark:divide-gray-700">
              <tr *ngFor="let certificat of certificatsPagines"
                class="group hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-all">

                <td class="px-6 py-5 font-bold text-gray-800 dark:text-gray-200">
                  {{ certificat.name }}
                </td>

                <td class="px-6 py-5 text-center text-gray-500 dark:text-gray-400 font-medium">
                  {{ certificat.cohorte }}
                </td>

                <td class="px-6 py-5 text-center">
                  <span
                    class="inline-flex items-center px-4 py-1.5 rounded-full text-[10px] uppercase tracking-widest text-white shadow-sm font-bold"
                    [style.backgroundColor]="
          certificat.status?.toLowerCase() === 'retenu' ? '#1FAC29' :
          (certificat.status?.toLowerCase() === 'rejeté' || certificat.status?.toLowerCase() === 'rejete') ? '#FE0000' :
          (certificat.status?.toLowerCase() === 'en cours' || certificat.status === 'En cours de traitement') ? '#EBAC0D' : '#CCCCCC'
        ">
                    {{ certificat.status || "N/A" }}
                  </span>
                </td>

                <td class="px-6 py-5 text-right">
                  <button (click)="voirDossier(ligneDetails, certificat)"
                    class="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-black text-[11px] uppercase tracking-tighter transition-colors group/btn">
                    <span>Évaluer</span>
                    <svg class="w-4 h-4 transition-transform group-hover/btn:translate-x-1" fill="none"
                      stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                        d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <mat-paginator #paginatorDetails [length]="ligneDetails?.certificats?.length || 0" [pageSize]="5"
            [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons class="bg-gray-50 dark:bg-gray-700/50">
          </mat-paginator>
        </div>

        <div class="mt-12 flex flex-col sm:flex-row justify-between items-center gap-6">
          <button type="button" (click)="closeModalDetails()"
            class="w-full sm:w-auto px-10 py-4 flex items-center justify-center bg-red-100 hover:bg-red-500 text-red-600 hover:text-white font-black text-xs uppercase tracking-widest rounded-2xl transition-all duration-200">
            Fermer
          </button>

          <button
            class="w-full sm:w-auto relative group overflow-hidden px-4 py-3 rounded-xl transition-all duration-300 shadow-sm flex items-center justify-center"
            (click)="delibererCandidats()" [disabled]="isNotifying || filteredCandidats.length === 0" [ngClass]="{
          'bg-blue-600 text-white hover:bg-blue-700 active:scale-95': !isNotifying && filteredCandidats.length > 0,
          'bg-gray-200 text-gray-400 cursor-not-allowed': isNotifying || filteredCandidats.length === 0
        }">
            <div class="flex items-center gap-1.5 relative z-10">
              <svg class="w-3.5 h-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
              <span class="font-black text-[10px] uppercase tracking-wider">
                {{ isNotifying ? "Envoi en cours ..." : "Délibérer candidat" }}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmation de délibération -->
<div *ngIf="showConfirmationModal" tabindex="-1" aria-hidden="true" style="z-index: 999999"
  class="h-full bg-opacity-70 bg-gray-100 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 outline-none focus:outline-none justify-center items-center flex max-h-full">
  <div class="relative w-full my-6 mx-auto max-w-md">
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Header -->
      <div class="flex items-center justify-between p-5 border-b rounded-t dark:border-gray-600">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
          Confirmation de délibération
        </h3>
        <button type="button" (click)="cancelDeliberation()"
          class="transition text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-2 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span class="sr-only">Fermer</span>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6">
        <div class="flex items-start mb-4">
          <div class="flex-shrink-0">
            <svg class="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <div class="ml-4">
            <p class="text-base text-gray-700 dark:text-gray-300">
              Voulez-vous vraiment délibérer et notifier le candidat
              <span class="font-semibold text-blue-600">
                {{ ligneDetails?.firstname }} {{ ligneDetails?.lastname }}
              </span>
              ?
            </p>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">
              Un email de notification sera envoyé à
              <span class="font-medium">{{ ligneDetails?.email }}</span>.
            </p>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end p-5 border-t border-gray-200 rounded-b dark:border-gray-600 gap-3">
        <button type="button" (click)="cancelDeliberation()"
          class="transition text-gray-700 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 font-semibold rounded-lg text-sm px-5 py-2.5 border border-gray-300 dark:bg-gray-600 dark:text-white dark:border-gray-500 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">
          Annuler
        </button>
        <button type="button" (click)="confirmDeliberation()"
          class="transition text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Confirmer
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Snackbars de notification -->
<div class="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-[999999]">
  <div class="bg-red-500 border border-red-600 text-white px-4 py-3 rounded relative shadow-lg" role="alert"
    *ngIf="errorSingle">
    <strong class="font-bold">Erreur!</strong><br />
    <span class="block sm:inline ml-2">{{ messageSingle }}</span>
  </div>

  <div class="bg-green-500 border border-green-600 text-white px-4 py-3 rounded relative shadow-lg" role="alert"
    *ngIf="succesSingle">
    <strong class="font-bold">Réussite!</strong><br />
    <span class="block sm:inline ml-2">{{ messageSingle }}</span>
  </div>
</div>